import { useActionData } from '@remix-run/react'
import {
	type HeadingField,
	type RowField,
} from '../../../types/graphql.form.ts'
import { FormieForm, type FormActionResult } from './index.tsx'

export default function FormField({
	field,
}: {
	field: RowField
	children: React.ReactNode
}) {
	const actionData = useActionData<FormActionResult>()
	const { type } = field

	const errors = actionData?.ok === false ? actionData.errors : {}
	const error = errors[field.handle] as string | null
	let el: JSX.Element
	switch (type) {
		case 'verbb\\formie\\fields\\formfields\\SingleLineText': {
			return <FormieForm.SingleLineText field={field} error={error} />
		}
		case 'verbb\\formie\\fields\\formfields\\Email': {
			return <FormieForm.Email field={field} error={error} />
		}
		case 'verbb\\formie\\fields\\formfields\\MultiLineText': {
			return <FormieForm.MultiLineText field={field} error={error} />
		}
		case 'verbb\\formie\\fields\\formfields\\Name': {
			return <FormieForm.Name field={field} error={error} />
		}
		case 'verbb\\formie\\fields\\formfields\\Heading': {
			const heading = field as HeadingField
			return <FormieForm.Heading field={heading} />
		}
		case 'verbb\\formie\\fields\\formfields\\Phone': {
			return <FormieForm.Phone field={field} error={error} />
		}
		case 'verbb\\formie\\fields\\formfields\\Dropdown':
		case 'verbb\\formie\\fields\\formfields\\Address': {
			el = <input />
			break
		}
		case 'verbb\\formie\\fields\\formfields\\Agree':
		case 'verbb\\formie\\fields\\formfields\\BaseOptionsField':
		case 'verbb\\formie\\fields\\formfields\\Calculations':
		case 'verbb\\formie\\fields\\formfields\\Categories':
		case 'verbb\\formie\\fields\\formfields\\Checkboxes':
		case 'verbb\\formie\\fields\\formfields\\Date':
		case 'verbb\\formie\\fields\\formfields\\Entries':
		case 'verbb\\formie\\fields\\formfields\\FileUpload':
		case 'verbb\\formie\\fields\\formfields\\Group':
		case 'verbb\\formie\\fields\\formfields\\Hidden':
		case 'verbb\\formie\\fields\\formfields\\Html':
		case 'verbb\\formie\\fields\\formfields\\MissingField':
		case 'verbb\\formie\\fields\\formfields\\Number':
		case 'verbb\\formie\\fields\\formfields\\Password':
		case 'verbb\\formie\\fields\\formfields\\Payment':

		case 'verbb\\formie\\fields\\formfields\\Products':
		case 'verbb\\formie\\fields\\formfields\\Radio':
		case 'verbb\\formie\\fields\\formfields\\Recipients':
		case 'verbb\\formie\\fields\\formfields\\Repeater':
		case 'verbb\\formie\\fields\\formfields\\Section':
		case 'verbb\\formie\\fields\\formfields\\Signature':
		case 'verbb\\formie\\fields\\formfields\\Summary':
		case 'verbb\\formie\\fields\\formfields\\Table':
		case 'verbb\\formie\\fields\\formfields\\Tags':
		case 'verbb\\formie\\fields\\formfields\\Users':
		case 'verbb\\formie\\fields\\formfields\\Variants':
		default: {
			el = <div>Yup {field.type}</div>
			break
		}
	}
	return el
}
